
import React from "react";

import API from "@dndUtilities/system_api";

const api = API.getInstance();

export default function Home() {
  return (
    <div>
      <h3>Welcome to Homebrew Labs</h3>
      <p>
        This is my system for keeping track of all things RPG.
      </p>
      <p>
        The hamburger button in the top left (3 horizontal lines) 
        can be used to access the main menu.
      </p>
      <p>
        Select a system to work with there.  
        At the time of writing this, the only one that does anything
        is D&amp;D.
      </p>
      <p>
        For further instructions, you'll have to ask me, 
        but I tried to make it as intuitive as possible, especially 
        for the Characters pages.
      </p>
      <p>
        Eventually I'll put tutorial videos here.
      </p>
      <p>v.{ api.version }</p>
    </div>
  );
}
